(function (app) {

    function tours(_) {
        var tours = [
            {
                name: "Calendar",
                steps: [
                    { content: 'Click "ADD AN EVENT"', media: '/Images/Tours/event-calendar.mp4' },
                ]
            },
            {
                name: "Event List",
                steps: []
            }
        ];
        var tour = {};
        return {
            getTours: function () {
                return tours;
            },
            //gettoursAJAX: function () {
            //    return $http.jsonp('');
            //},

            setTour: function (data) {
                tour = data;
            },
            getTour: function (tourName) {
                return _.find(tours, function (tour) {
                    return tour.name === tourName;
                });
            }
        };
    }
    tours.$inject = ["_"];

    app.service("tours", tours);

})(window.app); // jshint ignore:line